import PersonOutlineIcon from "@mui/icons-material/PersonOutline";

import { TestIds } from "@storyboard/web-test-ids/testIds";
import { type DriverRow, isSamsaraUsernameTag, type TagDefinition } from "@/types/driver";
import { ContextField, ContextText } from "./ContextBlock";
import { firstTagValue, NO_VALUE } from "./contextFormat";

/**
 * Who the driver is: their name, with their ELD username under it when the workspace's `Username` tag carries one.
 *
 * The tag is matched by label, which Platform Science's and Samsara's username configs both default to.
 */
export default function DriverField({ driver, tags }: { driver: DriverRow; tags: readonly TagDefinition[] }) {
  const username = firstTagValue(driver, tags, isSamsaraUsernameTag);
  return (
    <ContextField
      icon={<PersonOutlineIcon sx={{ fontSize: 18 }} />}
      label="Driver"
      testId={TestIds.dispatch.contextDriver}
    >
      <ContextText variant="value">{driver.name || NO_VALUE}</ContextText>
      {username && <ContextText variant="subtext">{username}</ContextText>}
    </ContextField>
  );
}
